import { CssBaseline, ThemeProvider } from "@mui/material"
import { createTheme } from "@mui/material/styles"
import { useMemo } from "react"
import { useSelector } from "react-redux"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { themeSettings } from "./theme"
import Layout from "scenes/layout"
import Dashboard from "scenes/dashboard"
import Login from "scenes/login"
import NewPassword from "scenes/newPassword"
import Users from "scenes/users"
import NewUser from "scenes/users/new"
import UserDelete from "scenes/users/userdelete"
import Admins from "scenes/admin"
import Kiosks from "scenes/kiosk"
import Facials from "scenes/facials"
import UpdateUserFacial from "scenes/facials/updatefacial"
import Commutes from "scenes/commute"

function App() {
  const mode = useSelector((state) => state.global.mode)
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode])
  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/users" element={<Users />} />
              <Route path="/users/new" element={<NewUser />} />
              <Route path="/users/userdelete" element={<UserDelete />} />
              <Route path="/facials" element={<Facials />} />
              <Route path="/kiosks" element={<Kiosks />} />
              <Route path="/admins" element={<Admins />} />
              <Route path="/updatefacial" element={<UpdateUserFacial />} />
              <Route path="/commutes" element={<Commutes />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/newpassword" element={<NewPassword />} />
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  )
}

export default App
